<template>
  <base-icon-button :title="title"
                    v-on="$listeners">
    <base-material-design-icon class="custom-text-danger"
                               icon="delete"/>
  </base-icon-button>
</template>

<script>
  import BaseIconButton from '@/components/base-components/base-icons/BaseIconButton';
  import BaseMaterialDesignIcon from '@/components/base-components/base-icons/BaseMaterialDesignIcon';

  export default {
    name: 'BaseIconButtonDelete',
    components: { BaseMaterialDesignIcon, BaseIconButton },
    props: {
      title: {
        type: String,
        default: 'Delete',
        validator: (value) => value.length > 0,
      },
    },
  };
</script>
